export const ErrorSvg = function ErrorSvg() {
    return (
        <svg
            width="100%"
            height="424px"
            viewBox="0 0 1086 424"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>404-error</title>
            <defs>
                <path
                    d="M0,283 C0,283 143.508806,283 370.526417,283 C401.170552,283 432.87729,398 481.203675,398 C513.236294,398 586.79889,398 626.600306,398 C664.143915,398 675.276668,283 719.732676,283 C784.715109,283 905.470884,283 1082,283"
                    id="path-1"
                />
                <filter
                    x="-0.3%"
                    y="-2.6%"
                    width="100.6%"
                    height="105.2%"
                    filterUnits="objectBoundingBox"
                    id="filter-2"
                >
                    <feMorphology
                        radius="2"
                        operator="dilate"
                        in="SourceAlpha"
                        result="shadowSpreadOuter1"
                    />
                    <feOffset dx="0" dy="0" in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
                    <feMorphology
                        radius="2"
                        operator="erode"
                        in="SourceAlpha"
                        result="shadowInner"
                    />
                    <feOffset dx="0" dy="0" in="shadowInner" result="shadowInner" />
                    <feComposite
                        in="shadowOffsetOuter1"
                        in2="shadowInner"
                        operator="out"
                        result="shadowOffsetOuter1"
                    />
                    <feColorMatrix
                        values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0"
                        type="matrix"
                        in="shadowOffsetOuter1"
                    />
                </filter>
                <polygon
                    id="path-3"
                    points="30 266.5 133.521951 123.5 222 218.5 279.021079 169.5 339 242.418748 368.5 279.680202 18.5 279.680202"
                />
                <filter
                    x="-1.5%"
                    y="-2.7%"
                    width="103.0%"
                    height="104.6%"
                    filterUnits="objectBoundingBox"
                    id="filter-4"
                >
                    <feMorphology
                        radius="1"
                        operator="dilate"
                        in="SourceAlpha"
                        result="shadowSpreadOuter1"
                    />
                    <feOffset dx="0" dy="0" in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
                    <feColorMatrix
                        values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0"
                        type="matrix"
                        in="shadowOffsetOuter1"
                    />
                </filter>
                <polygon
                    id="path-5"
                    points="827.450906 108 928 209.5 972.5 177.5 1066 279 709 279"
                />
                <filter
                    x="-1.3%"
                    y="-2.4%"
                    width="102.9%"
                    height="104.2%"
                    filterUnits="objectBoundingBox"
                    id="filter-6"
                >
                    <feMorphology
                        radius="1"
                        operator="dilate"
                        in="SourceAlpha"
                        result="shadowSpreadOuter1"
                    />
                    <feOffset dx="0" dy="0" in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
                    <feColorMatrix
                        values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0"
                        type="matrix"
                        in="shadowOffsetOuter1"
                    />
                </filter>
            </defs>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="Light---Block-Model-Dashboard---404"
                    transform="translate(-297.000000, -172.000000)"
                >
                    <g id="Group-3" transform="translate(19.000000, 83.500000)">
                        <g id="404-error" transform="translate(280.000000, 89.500000)">
                            <g id="Path-6" strokeLinecap="round">
                                <use
                                    fill="black"
                                    fillOpacity="1"
                                    filter="url(#filter-2)"
                                    href="#path-1"
                                />
                                <use stroke="#D8D8D8" strokeWidth="2" href="#path-1" />
                            </g>
                            <g id="Path-8" fillRule="nonzero">
                                <use
                                    fill="black"
                                    fillOpacity="1"
                                    filter="url(#filter-4)"
                                    href="#path-3"
                                />
                                <use fill="#F2F2F2" href="#path-3" />
                            </g>
                            <g id="Path-10" fillRule="nonzero">
                                <use
                                    fill="black"
                                    fillOpacity="1"
                                    filter="url(#filter-6)"
                                    href="#path-5"
                                />
                                <use fill="#F2F2F2" href="#path-5" />
                            </g>
                            <polygon
                                id="Path-15"
                                fill="#FAFAFA"
                                fillRule="nonzero"
                                points="70.7954754 223 132.021951 121.5 227.059896 228 159.5 186.5 151.408171 186.5 148 175.848358 132.021951 193.145833 132.021951 159.916667"
                            />
                            <polygon
                                id="Path-15"
                                fill="#FAFAFA"
                                fillRule="nonzero"
                                transform="translate(809.746079, 175.741140) scale(-1, 1) translate(-809.746079, -175.741140) "
                                points="740 160 792.490826 113.989991 879.492158 237.492289 800.847736 154.5 784.307698 154.5 779.713924 145.9375"
                            />
                            <path
                                d="M227.059896,217.178385 L279.521951,171 L286.398438,182 C281.729292,180.562078 275.089535,182.395411 266.479167,187.5 C257.868798,192.604589 244.729041,202.497384 227.059896,217.178385 Z"
                                id="Path-15"
                                fill="#FAFAFA"
                                fillRule="nonzero"
                            />
                            <path
                                d="M250.406121,50 C251.169819,47.2260869 251.229297,44.216379 250.395415,41.2441565 C248.721705,35.2876194 243.963466,31.0820092 238.38681,29.8921528 C238.592604,29.1001244 238.71156,28.2718199 238.71156,27.4132854 C238.71156,22.0323292 234.420818,17.6707317 229.127277,17.6707317 C226.126017,17.6707317 223.449508,19.0746171 221.691339,21.2693217 C216.406125,11.8883199 205.734584,6.41667349 194.658593,8.40702266 C181.469944,10.7758526 172.382897,22.8836085 173.288152,36.1691289 C172.459029,35.9430078 171.588271,35.813623 170.684206,35.813623 C165.335945,35.813623 161,40.0385805 161,45.2502481 C161,46.9842461 161.487719,48.604579 162.326359,50 L250.406121,50 Z"
                                id="Fill-1"
                                fill="#D1DFE7"
                                fillRule="nonzero"
                                opacity="0.528506324"
                            />
                            <path
                                d="M772.577686,30 C773.12076,28.0186335 773.163056,25.8688422 772.570073,23.7458261 C771.379879,19.4911567 767.996242,16.4871494 764.03062,15.637252 C764.176963,15.0715174 764.261553,14.4798714 764.261553,13.8666324 C764.261553,10.0230923 761.210359,6.90766549 757.446063,6.90766549 C755.311835,6.90766549 753.408539,7.91044079 752.158285,9.47808693 C748.399911,2.77737137 740.81126,-1.13094751 732.935,0.290730475 C723.556405,1.98275184 717.094505,10.631149 717.738242,20.1208063 C717.148643,19.9592913 716.529437,19.8668736 715.886546,19.8668736 C712.083339,19.8668736 709,22.8847003 709,26.6073201 C709,27.8458901 709.346823,29.0032707 709.943189,30 L772.577686,30 Z"
                                id="Fill-1"
                                fill="#D1DFE7"
                                fillRule="nonzero"
                                opacity="0.508184524"
                                transform="translate(741.000000, 15.000000) scale(-1, 1) translate(-741.000000, -15.000000) "
                            />
                            <path
                                d="M360.571088,123 C361.122647,121.018633 361.165603,118.868842 360.563356,116.745826 C359.354565,112.491157 355.918059,109.487149 351.890474,108.637252 C352.039103,108.071517 352.125015,107.479871 352.125015,106.866632 C352.125015,103.023092 349.026146,99.9076655 345.203033,99.9076655 C343.035457,99.9076655 341.102422,100.910441 339.832633,102.478087 C336.015534,95.7773714 328.308311,91.8690525 320.308984,93.2907305 C310.783849,94.9827518 304.220981,103.631149 304.874777,113.120806 C304.275965,112.959291 303.647085,112.866874 302.994149,112.866874 C299.131516,112.866874 296,115.8847 296,119.60732 C296,120.84589 296.352242,122.003271 296.957926,123 L360.571088,123 Z"
                                id="Fill-1"
                                fill="#D1DFE7"
                                fillRule="nonzero"
                                opacity="0.508184524"
                            />
                            <path
                                d="M983.41272,70 C984.167932,67.358178 984.226749,64.4917895 983.402133,61.6611014 C981.747019,55.988209 977.04165,51.9828659 971.526956,50.8496693 C971.730464,50.0953566 971.848098,49.3064952 971.848098,48.4888432 C971.848098,43.364123 967.605031,39.2102207 962.370307,39.2102207 C959.402395,39.2102207 956.755624,40.5472544 955.01699,42.6374492 C949.790501,33.7031618 939.237533,28.49207 928.284609,30.3876406 C915.2425,32.6436691 906.256421,44.1748653 907.151617,56.8277418 C906.331707,56.6123884 905.470624,56.4891648 904.576604,56.4891648 C899.287768,56.4891648 895,60.5129338 895,65.4764268 C895,67.1278535 895.4823,68.6710276 896.311622,70 L983.41272,70 Z"
                                id="Fill-1"
                                fill="#D1DFE7"
                                fillRule="nonzero"
                                opacity="0.508184524"
                                transform="translate(939.500000, 50.000000) scale(-1, 1) translate(-939.500000, -50.000000) "
                            />
                            <path
                                d="M339.527043,173.748743 L304.758549,173.69173 C301.76197,173.686824 299.314243,176.133989 299.319156,179.129881 L299.363276,206.032993 L275.292571,205.993527 C272.295992,205.988614 269.848265,208.435779 269.853171,211.431671 L269.897674,238.563561 C269.902587,241.559453 272.358354,244.014658 275.354933,244.019571 L359.825782,244.158076 C362.825085,244.162986 365.270088,241.715817 365.265175,238.719925 L365.250047,229.4953 C365.529564,228.842111 365.683662,228.123351 365.682432,227.368931 L365.679852,225.800173 L339.527043,173.748743 Z"
                                id="Stroke-7"
                                stroke="#265C7F"
                                strokeWidth="3"
                                fill="#D1DFE7"
                                fillRule="nonzero"
                                transform="translate(317.767801, 208.924903) rotate(-1.000000) translate(-317.767801, -208.924903) "
                            />
                            <path
                                d="M365.827323,281.446611 L290.896493,281.323717 C275.439592,281.298374 262.776018,268.63498 262.750641,253.184346 C262.725341,237.733713 275.347448,225.111776 290.804349,225.137081 L365.735179,225.259975 C381.19208,225.285318 393.855655,237.948713 393.881031,253.399346 C393.906332,268.84998 381.284224,281.471916 365.827323,281.446611 Z"
                                id="Stroke-3"
                                stroke="#265C7F"
                                strokeWidth="3"
                                fill="#FFFFFF"
                                fillRule="nonzero"
                                transform="translate(328.315836, 253.291846) rotate(-1.000000) translate(-328.315836, -253.291846) "
                            />
                            <path
                                d="M377.014347,264.145214 C371.039174,270.119015 361.332981,270.103101 355.338181,264.109674 C349.343382,258.116247 349.327468,248.412279 355.302641,242.438478 C361.277815,236.464677 370.984008,236.480592 376.978807,242.474019 C382.973606,248.467445 382.98952,258.171413 377.014347,264.145214 Z"
                                id="Stroke-5"
                                stroke="#265C7F"
                                strokeWidth="3"
                                fill="#D1DFE7"
                                fillRule="nonzero"
                                transform="translate(366.158494, 253.291846) rotate(-1.000000) translate(-366.158494, -253.291846) "
                            />
                            <path
                                d="M302.920527,264.145214 C296.945353,270.119015 287.23916,270.103101 281.244361,264.109674 C275.249562,258.116247 275.233648,248.412279 281.208821,242.438478 C287.183994,236.464677 296.890187,236.480592 302.884987,242.474019 C308.879786,248.467445 308.8957,258.171413 302.920527,264.145214 Z"
                                id="Stroke-1"
                                stroke="#265C7F"
                                strokeWidth="3"
                                fill="#D1DFE7"
                                fillRule="nonzero"
                                transform="translate(292.064674, 253.291846) rotate(-1.000000) translate(-292.064674, -253.291846) "
                            />
                            <path
                                d="M337.723286,207.675791 L312.690951,207.634741 C309.694372,207.629828 307.238605,205.174623 307.233692,202.178731 L307.206488,185.595106 C307.201582,182.599213 309.649309,180.152049 312.645888,180.156954 L330.047842,180.185494 C333.047146,180.190411 334.448116,182.311616 335.862713,186.09692 L343.162686,202.23764 C343.167592,205.233532 340.719865,207.680697 337.723286,207.675791 Z"
                                id="Stroke-9"
                                stroke="#265C7F"
                                strokeWidth="3"
                                fill="#FFFFFF"
                                fillRule="nonzero"
                                transform="translate(325.184587, 193.916373) rotate(-1.000000) translate(-325.184587, -193.916373) "
                            />
                            <g
                                id="Group"
                                transform="translate(490.790952, 368.066253) rotate(8.000000) translate(-490.790952, -368.066253) translate(432.290952, 324.566253)"
                                fillRule="nonzero"
                            >
                                <polygon
                                    id="Stroke-11"
                                    stroke="#265C7F"
                                    strokeWidth="3"
                                    fill="#FFFFFF"
                                    transform="translate(85.877121, 30.877072) rotate(137.000000) translate(-85.877121, -30.877072) "
                                    points="65.7342768 28.7609207 95.9737725 8 106.019966 17.6659423 78.6441767 53.7541443"
                                />
                                <polygon
                                    id="Stroke-15"
                                    stroke="#265C7F"
                                    strokeWidth="3"
                                    fill="#FFFFFF"
                                    transform="translate(64.961352, 57.315591) rotate(137.000000) translate(-64.961352, -57.315591) "
                                    points="87.7732084 75.3420933 67.9031629 75.3095145 42.1494947 49.036961 51.8996069 39.2890882"
                                />
                                <polygon
                                    id="Stroke-17"
                                    stroke="#265C7F"
                                    strokeWidth="3"
                                    fill="#D1DFE7"
                                    transform="translate(29.268785, 34.740916) rotate(137.000000) translate(-29.268785, -34.740916) "
                                    points="34.7518784 57.7761084 23.3975086 57.722086 23.5933211 52.5395273 31.3618513 47.0915847 25.7049847 32.8763715 12 26.3800675 12.0249694 11.7057229 46.5375701 11.8712507 46.4817251 49.2461764"
                                />
                                <path
                                    d="M95.2160335,54.6812611 C95.2236597,59.3385118 91.4541602,63.1071454 86.7958414,63.0995193 C82.1375225,63.0918699 78.3583661,59.3108596 78.3507167,54.6536089 C78.343095,49.9990817 82.1098658,46.22772 86.7681847,46.2353462 C91.4265036,46.2429955 95.2083887,50.0267339 95.2160335,54.6812611 Z"
                                    id="Stroke-13"
                                    stroke="#265C7F"
                                    strokeWidth="3"
                                    fill="#FFFFFF"
                                    transform="translate(86.783375, 54.667433) rotate(137.000000) translate(-86.783375, -54.667433) "
                                />
                                <polygon
                                    id="Path-14"
                                    fillOpacity="0.3"
                                    fill="#265C7F"
                                    transform="translate(24.619602, 38.261473) rotate(137.000000) translate(-24.619602, -38.261473) "
                                    points="16.3616835 58.1111395 25.26001 56.6964182 32.8775197 50.8498008 32.8101281 18.4118069 30.118771 21.2979341 25.0148812 49.9928018"
                                />
                            </g>
                            <path
                                d="M273.848691,225.093063 C274.566386,224.323429 303.811767,223.536725 361.584835,222.73295 L356.951825,218.412599 L288.749712,219.5634 L281.384491,217.011907 L272.758879,210.587151 C272.767725,221.027393 273.130995,225.862697 273.848691,225.093063 Z"
                                id="Path-2"
                                fill="#FFFFFF"
                                fillRule="nonzero"
                                opacity="0.667526972"
                                transform="translate(317.171857, 217.879738) rotate(-1.000000) translate(-317.171857, -217.879738) "
                            />
                            <path
                                d="M367.325133,213.426443 C373.779724,211.477438 374.583668,197.184738 367.325133,197.184738 C360.870542,197.184738 371.843347,210.178102 380.234314,205.630425 C385.204726,202.936597 391.528706,194.786894 388.606372,188.714943 C384.141311,179.437551 374.048089,187.110174 381.747109,193.885642 C388.826142,200.115495 395.025493,196.030049 399.379062,189.181418"
                                id="Path-5"
                                stroke="#265C7F"
                                strokeWidth="2"
                                opacity="0.5"
                                transform="translate(382.379062, 198.926443) rotate(-10.000000) translate(-382.379062, -198.926443) "
                            />
                            <path
                                d="M379.43964,223.22594 C382.799992,222.217834 379.756398,210.580796 377.100666,215.575501 C375.629335,218.342673 384.833888,220.325769 389.202346,217.973522 C391.790014,216.580163 394.879256,213.745847 393.357847,210.605183 C391.033272,205.806531 386.773084,208.93405 390.781304,212.438602 C394.466751,215.66094 396.902846,213.00781 399.169377,209.465415"
                                id="Path-5"
                                stroke="#265C7F"
                                strokeWidth="2"
                                opacity="0.504324777"
                                transform="translate(388.056230, 215.688675) scale(-1, -1) rotate(17.000000) translate(-388.056230, -215.688675) "
                            />
                            <path
                                d="M561.850454,376.228516 L567.454727,385.568971 L561.461854,394.904456 L551.030508,394.904456 L545.97168,385.568971 L550.641907,376.228516 L561.850454,376.228516 Z M556.713204,380.964607 C554.171656,380.964607 552.111325,383.024938 552.111325,385.566486 C552.111325,388.108033 554.171656,390.168365 556.713204,390.168365 C559.254751,390.168365 561.315083,388.108033 561.315083,385.566486 C561.315083,383.024938 559.254751,380.964607 556.713204,380.964607 Z"
                                id="Combined-Shape"
                                fill="#265C7F"
                                fillRule="nonzero"
                                opacity="0.45"
                            />
                            <path
                                d="M572.441978,362.65987 L575.436199,364.646594 L575.041514,371.73987 L575.374546,371.352332 L595.483318,387.91175 L595.520403,392.290614 L590.908581,392.382319 L570.931514,377.00987 L569.915246,378.266599 L563.907545,379.421853 L560.357514,377.280947 L565.175734,370.827364 L567.279322,371.740455 L569.168124,369.543751 L567.523974,368.096327 L572.441978,362.65987 Z"
                                id="Combined-Shape"
                                stroke="#265C7F"
                                fill="#265C7F"
                                fillRule="nonzero"
                                opacity="0.45"
                                transform="translate(577.938958, 377.521094) scale(-1, 1) rotate(90.000000) translate(-577.938958, -377.521094) "
                            />
                            <line
                                x1="578.213145"
                                y1="371.961638"
                                x2="579.252107"
                                y2="383.020714"
                                id="Line"
                                stroke="#FFFFFF"
                                strokeWidth="2"
                                strokeLinecap="square"
                                transform="translate(578.732626, 377.491176) scale(-1, 1) rotate(97.000000) translate(-578.732626, -377.491176) "
                            />
                            <line
                                x1="583.16664"
                                y1="378.525188"
                                x2="583.6384"
                                y2="388.19913"
                                id="Line"
                                stroke="#FFFFFF"
                                strokeWidth="2"
                                strokeLinecap="square"
                                transform="translate(583.402520, 383.362159) scale(-1, 1) rotate(97.000000) translate(-583.402520, -383.362159) "
                            />
                            <line
                                x1="587.469304"
                                y1="384.897081"
                                x2="587.733485"
                                y2="393.638947"
                                id="Line"
                                stroke="#FFFFFF"
                                strokeWidth="2"
                                strokeLinecap="square"
                                transform="translate(587.601395, 389.268014) scale(-1, 1) rotate(97.000000) translate(-587.601395, -389.268014) "
                            />
                            <path
                                d="M558.534793,330.129203 C556.416065,331.186197 553.659495,331.517363 552.178611,333.300183 C543.181958,344.131158 564.225998,342.95724 557.863544,353.106752 C556.018401,356.05016 552.010003,357.12172 549.083233,359.129203"
                                id="Path-11"
                                stroke="#265C7F"
                                strokeWidth="3"
                                opacity="0.2"
                                fillRule="nonzero"
                                transform="translate(554.083233, 344.629203) scale(-1, -1) rotate(-3.000000) translate(-554.083233, -344.629203) "
                            />
                            <path
                                d="M566.284723,312.550638 C565.070788,314.593067 556.329096,325.925569 561.080895,330.465908 C566.137642,335.297626 573.426976,334.268488 567.405266,341.550638"
                                id="Path-12"
                                stroke="#265C7F"
                                strokeWidth="3"
                                opacity="0.2"
                                fillRule="nonzero"
                                transform="translate(564.677761, 327.050638) scale(-1, 1) rotate(3.000000) translate(-564.677761, -327.050638) "
                            />
                            <line
                                x1="557.741881"
                                y1="310.810818"
                                x2="560.741881"
                                y2="307.810818"
                                id="Path-13"
                                stroke="#265C7F"
                                strokeWidth="3"
                                opacity="0.2"
                                fillRule="nonzero"
                                transform="translate(559.241881, 309.310818) scale(-1, 1) rotate(3.000000) translate(-559.241881, -309.310818) "
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};
